module.exports = __webpack_public_path__ + "static/media/4.2.366c14b1.zip";